export default __webpack_public_path__ + "static/media/facebook.2e844453.svg";